import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { CONTACT } from '../data';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/10 mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center font-bold">E</div>
            <span className="font-display text-xl">Express Detailz</span>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Professional mobile detailing in Lincoln, Nebraska. We bring showroom-quality results to your driveway.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-blue-500 hover:text-blue-400 transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-blue-500 hover:text-blue-400 transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5 font-bold">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="text-zinc-300 hover:text-white">Services</Link></li>
            <li><Link to="/pricing" className="text-zinc-300 hover:text-white">Pricing</Link></li>
            <li><Link to="/gallery" className="text-zinc-300 hover:text-white">Gallery</Link></li>
            <li><Link to="/about" className="text-zinc-300 hover:text-white">About</Link></li>
            <li><Link to="/faq" className="text-zinc-300 hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="text-zinc-300 hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5 font-bold">Get In Touch</h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-blue-400" /> {CONTACT.phone}</li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-blue-400" /> {CONTACT.email}</li>
            <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-blue-400" /> {CONTACT.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 px-6 md:px-10 max-w-7xl mx-auto flex flex-col md:flex-row gap-3 justify-between items-center text-xs text-zinc-500">
        <p>© {new Date().getFullYear()} Express Detailz. All rights reserved.</p>
        <p>Lincoln, NE — Professional Mobile Auto Detailing</p>
      </div>
    </footer>
  );
}
